import { ReactNode } from "react";
import ListBox from "@ingka/list-box";
import "@ingka/svg-icon/dist/style.css";
import "@ingka/list-box/dist/style.css";

interface ListBoxProps {
  children: ReactNode | ReactNode[];
  className?: string;
  multiple?: boolean;
  open: boolean;
  position?: "left" | "right";
  value?: string[];
}

export const FixaListBox = (props: ListBoxProps) => {
  return <ListBox {...props} />;
};
